import apiClient from "../core/apiClient";
import { BaseService } from "./BaseService";
import { PreadviceTask } from "../interfaces/DTO/tasks/PreadviceTasks";
import { CreateAndSendForClientSigningDTO } from "../interfaces/DTO/user";

const PREADVICE_TASKS_API_URL = "/preadvice_tasks";

class PreadviceTasksService extends BaseService<PreadviceTask> {
  constructor() {
    super(PREADVICE_TASKS_API_URL);
  }

  async getTasksByUser(userId: number, skip: number = 0, limit: number = 10): Promise<PreadviceTask[]> {
    const response = await apiClient.get<PreadviceTask[]>(`${this.baseUrl}/user/${userId}`, {
      params: { skip, limit },
    });
    return response.data;
  }

  async getTasksByContact(contactId: number, skip: number = 0, limit: number = 10): Promise<PreadviceTask[]> {
    const response = await apiClient.get<PreadviceTask[]>(`${this.baseUrl}/contact/${contactId}`, {
      params: { skip, limit },
    });
    return response.data;
  }
  async processTask(userId: number): Promise<string> {
    const response = await apiClient.post(`${this.baseUrl}/process/${userId}`, {});
    return response.data;
  }

  
  async createAndSendForClientSigning(data: CreateAndSendForClientSigningDTO): Promise<PreadviceTask> {
    const response = await apiClient.post<PreadviceTask>(`${this.baseUrl}/create_and_send_for_client_signing`, data);
    return response.data;
  }

  async getAllTasks(skip: number = 0, limit: number = 1000): Promise<PreadviceTask[]> {
    return this.getAll({ skip, limit });
  }

 
  async getTaskByExternalId(externalId: string): Promise<PreadviceTask> {
    const response = await apiClient.get<PreadviceTask>(`${this.baseUrl}/external/${externalId}`, {
      params: {},
    });
    return response.data;
  }

  
  async createTask(taskData: PreadviceTask): Promise<PreadviceTask> {
    const response = await apiClient.post<PreadviceTask>(`${this.baseUrl}/create`, taskData, {
      params: {},
    });
    return response.data;
  }



  async deleteTasksByUser(userId: number): Promise<number> {
    const response = await apiClient.delete<number>(`${this.baseUrl}/user/${userId}`, {
      params: {},
    });
    return response.data;
  }

  async requestPreAdviceForContact(contactId: number): Promise<{ success: boolean; message: string; external_id: string }> {
    const response = await apiClient.post(`${this.baseUrl}/request-pre-advice/${contactId}`);
    return response.data;
  }

  
  async runProcessingNow(): Promise<{ status: string; company_id: number }> {
    const response = await apiClient.post<{ status: string; company_id: number }>(`${this.baseUrl}/run-now`);
    return response.data;
  }
}

export const preadviceTasksService = new PreadviceTasksService();
